export const PIE_COLORS = [
  '#65C3F8',
  '#F3D47D',
  '#AAD575',
  '#E78A82',
  '#53C4C7',
  '#E67BA9',
  '#AC93C3',
  '#A8A9AA',
  '#ECA863',
  '#94D7FA',
  '#F8E2A6',
  '#C5E2A2',
  '#EEAFAA',
  '#87D9DB',
  '#EDA4C6',
  '#84d575'
];
